import { useEffect, useState } from "react";
import { getCompanyNamesAuto4client } from "../../../services/gsuite/sheets";

/**
 * Custom hook to fetch and manage company names
 * @returns {Object} Company names state and related functions
 */
function useCompanyNames() {
  const [companyNames, setCompanyNames] = useState([]);

  const fetchCompanyNames = async () => {
    const companyNamesRes = await getCompanyNamesAuto4client();
    const companyNamesJson = await companyNamesRes.json();
    setCompanyNames(companyNamesJson.company_names.sort());
  };

  useEffect(() => {
    fetchCompanyNames();
  }, []);

  return {
    companyNames,
    fetchCompanyNames,
  };
}
export default useCompanyNames;
